import { useTheme } from "@mui/material/styles";

/**
 * Custom hook to access the extended color palette from MUI theme
 * This provides a convenient way to access all custom colors defined in the theme
 */
export const useThemeColors = () => {
  const theme = useTheme();
  return theme.palette.color;
};

/**
 * Hook that provides direct access to specific color categories
 * Usage: const { main, content, cyan, blue, orange, yellow, red, green } = useColors();
 */
export const useColors = () => {
  const colors = useThemeColors();
  return {
    main: colors.main,
    content: colors.content,
    cyan: colors.cyan,
    blue: colors.blue,
    orange: colors.orange,
    yellow: colors.yellow,
    red: colors.red,
    green: colors.green,
  };
};
